import React, { useEffect, useState } from 'react';
import NavBar from '../../components/userHomeNavBar/navBar';
import SideBar from '../../components/userHomeSideBar/sideBar';
import BlogPost from '../../components/blogPost/blogPost';
import { useAuth } from '../../context/DBContext'; 
import ReactLoading from 'react-loading';  // Import the loading animation
import { 
  FacebookFilled, InstagramFilled, XOutlined, TikTokOutlined,
  PlusOutlined, LoadingOutlined, DeleteOutlined, EditOutlined
} from '@ant-design/icons';

import { Layout, Spin, Button, Space, Card, Typography, Pagination, Modal, message } from 'antd';
const { Title, Text } = Typography;

const { Content } = Layout;

const BlogPage = () => {
  const { fetchBlogs, currentUser, getUserInfo, importServicesFromJson, fetchServices, deleteBlog } = useAuth(); // Use the fetchBlogs function from DBContext
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [userInfo, setUserInfo] = useState(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 2;

  useEffect(() => {
    const loadBlogs = async () => {
      setLoading(true);
      try {
        const fetchedBlogs = await fetchBlogs();
        setBlogs(fetchedBlogs);
      } catch (err) {
        setError('Failed to fetch blogs');
      } finally {
        setLoading(false);
      }
    };
    loadBlogs();
  }, [fetchBlogs]);

  useEffect(() => {
    if (currentUser) {
      getUserInfo(currentUser.uid).then((data) => {
        setUserInfo(data);
      }).catch((error) => {
        setError('Failed to fetch user info');
      });
    }
  }, [currentUser, getUserInfo]);

  // Handle delete blog
  const handleDeleteBlog = async (blogId) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this blog post?',
      content: 'This action cannot be undone.',
      okText: 'Yes, delete it',
      okType: 'danger',
      cancelText: 'No, keep it',
      onOk: async () => {
        try {
          setLoading(true);
          await deleteBlog(blogId);
          // Remove the deleted blog from the state
          setBlogs(prevBlogs => prevBlogs.filter(blog => blog.id !== blogId));
          message.success('Blog deleted successfully');
        } catch (err) {
          message.error('Failed to delete blog');
          // console.error(err);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // Calculate the blogs to display based on current page
  const indexOfLastBlog = currentPage * pageSize;
  const indexOfFirstBlog = indexOfLastBlog - pageSize;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0); // Scroll to top on page change
  };


  
  return (
    <section className="">
      <div className="block-header">
        <div className="row">
          <div className="col-lg-7 col-md-6 col-sm-12">
            <Title level={3}>Blog</Title>
          </div>
          <div className="col-lg-5 col-md-6 col-sm-12" style={{ textAlign: 'right' }}>
            {userInfo && userInfo.role === 'admin' && (
              <Button 
                type="primary" 
                icon={<PlusOutlined />} 
                href="/createblog"
              >
                Create Blog
              </Button>
            )}
          </div>
        </div>
      </div>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        </div>
      ) : (
        <div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-8 col-md-12 left-box">
                {currentBlogs.map(blog => {
                  const firstImage = blog.content.find(section => section.type === 'image');
                  const firstText = blog.content.find(section => section.type === 'text');
                  
                  return (
                    <div key={blog.id} style={{ position: 'relative' }}>
                      {userInfo && userInfo.role === 'admin' && (
                        <Space style={{
                          position: 'absolute',
                          top: '10px',
                          right: '10px',
                          zIndex: 1
                        }}>
                        {/* Edit Blog    <Button
                            type="primary"
                            icon={<EditOutlined />}
                            onClick={() => window.location.href = `/editblog/${blog.id}`}
                          >
                            Edit
                          </Button>*/}
                       
                          <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => handleDeleteBlog(blog.id)}
                          >
                            Delete
                          </Button>
                        </Space>
                      )}
                      <BlogPost
                        id={blog.id}
                        title={blog.title}
                        author={blog.author}
                        category={blog.category}
                        comments={blog.comments ? blog.comments.length : 0}  // Ensure comments are handled safely
                        images={firstImage ? [firstImage.value] : []}  // Use the first image's URL if available
                        textContent={firstText ? firstText.value : ''}  // Use the first text content
                        readMoreLink={`/blog/${blog.id}`}
                      />
                    </div>
                  );
                })}

                {/* Pagination Controls */}
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '30px' }}>
                  <Pagination 
                    current={currentPage} 
                    pageSize={pageSize} 
                    total={blogs.length} 
                    onChange={handlePageChange} 
                    showSizeChanger={false}
                  />
                </div>
              </div>
              
              <div className="col-lg-4 col-md-12 right-box">
                <Card title="Connect with Us!" style={{ textAlign: 'center' }}>
                  <Space size="large" align="center">
                  <a href="https://www.facebook.com/profile.php?id=61557428587972" target="_blank" rel="noopener noreferrer">
        <FacebookFilled style={{ fontSize: '40px', color: '#3b5998' }} />
      </a>
      <a href="https://www.instagram.com/enablesend?fbclid=IwZXh0bgNhZW0CMTAAAR1PL1Cp4BD_Wc6nkKNPY1YlWD7oAedkCZ2igdCUCAaNS1MwDmcje63fzpo_aem_lPkZ_hV4WYU2Uu03aKLRMg" target="_blank" rel="noopener noreferrer">
        <InstagramFilled style={{ fontSize: '40px', color: '#E1306C' }} />
      </a>
      <a href="https://x.com/enablesend?fbclid=IwZXh0bgNhZW0CMTAAAR3GljV7-5ilFbMlx70x2sj-nYP1OMLdvJtDNQay6e7-SbWpF2s9y3H_QzY_aem_7stYq6XNRsdZWLC5lpLPpA" target="_blank" rel="noopener noreferrer">
        <XOutlined style={{ fontSize: '40px', color: '#1DA1F2' }} />
      </a>
      <a href="https://www.tiktok.com/@enablesend?fbclid=IwY2xjawH-RadleHRuA2FlbQIxMAABHSWzIlXL09lSwWrT5BVZHjP44bx4-LS_DaR1UGS5fc4bPj1SfQXTl98fvA_aem_aas9WQk3rei0vbhRqJOIiA" target="_blank" rel="noopener noreferrer">
        <TikTokOutlined style={{ fontSize: '40px', color: '#0077b5' }} />
      </a>
                   
                  </Space>
                  <Text type="secondary" style={{ display: 'block', marginTop: '10px' }}>
                    @enableSEND
                  </Text>
                </Card>

                {/* Added Space Between Sections */}
                <div style={{ marginTop: '40px' }}>
                  <Card
                    title="Sponsored"
                    style={{ textAlign: 'center' }}
                    cover={
                      <img
                        alt="Advertisement"
                        src="/assets/advertise-here.png"
                        style={{ objectFit: 'contain', width: '100%', height: '150px' }}
                      />
                    }
                  >
                    <p>Advertise here! Contact us for more information</p>
                    <Button type="primary mt-2" href="/contact">
                      Contact Us
                    </Button>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section> 
  );
};

export default BlogPage;
